import { Component, Inject, OnInit, Optional } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { Response } from 'express';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error401',
  templateUrl: './error401.component.html',
  styleUrls: ['./error401.component.scss']
})
export class Error401Component implements OnInit {

  private response: Response;
  private sourcePage: string | undefined = "";

  constructor(public helpersService: HelpersService,
              private router : Router,
              @Optional() @Inject(RESPONSE) response: any) { 
                this.response = response;
                this.sourcePage = this.router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
              }

  ngOnInit(): void {
    this.helpersService.setDataLayerError(401, this.sourcePage);
    if (this.response) {
      this.response.status(401);
    }
  }
}